// Derivación de edad para el flujo legal/consentimiento de MYKLUBB.
// Toda la aritmética usa campos de fecha locales de forma consistente para no
// depender de la zona horaria del entorno. `asOf` es inyectable (default: hoy)
// para que la lógica sea determinista y testeable.

export const MAYORIA_DE_EDAD = 18
export const GRACIA_RECONSENTIMIENTO_DIAS = 30

// Convierte string ISO ('YYYY-MM-DD'), string libre o Date a Date local; null si es inválido.
const parseFecha = (input) => {
  if (input == null || input === '') return null
  if (input instanceof Date) return isNaN(input.getTime()) ? null : input
  if (typeof input === 'string') {
    const m = input.trim().match(/^(\d{4})-(\d{2})-(\d{2})/)
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    const d = new Date(input)
    return isNaN(d.getTime()) ? null : d
  }
  return null
}

export const getAge = (fechaNacimiento, asOf = new Date()) => {
  const birth = parseFecha(fechaNacimiento)
  if (!birth) return null
  const ref = parseFecha(asOf) || new Date()
  let age = ref.getFullYear() - birth.getFullYear()
  const antesDelCumple =
    ref.getMonth() < birth.getMonth() ||
    (ref.getMonth() === birth.getMonth() && ref.getDate() < birth.getDate())
  if (antesDelCumple) age -= 1
  return age
}

export const isMinor = (fechaNacimiento, asOf = new Date()) => {
  const age = getAge(fechaNacimiento, asOf)
  return age == null ? null : age < MAYORIA_DE_EDAD
}

export const isAdult = (fechaNacimiento, asOf = new Date()) => {
  const age = getAge(fechaNacimiento, asOf)
  return age == null ? null : age >= MAYORIA_DE_EDAD
}

export const fechaCumple18 = (fechaNacimiento) => {
  const birth = parseFecha(fechaNacimiento)
  if (!birth) return null
  return new Date(birth.getFullYear() + MAYORIA_DE_EDAD, birth.getMonth(), birth.getDate())
}

// Un jugador que consintió siendo menor (firmó el tutor) y ya es mayor de edad
// debe volver a consentir por sí mismo. No aplica si consintió como jugador adulto
// ni si aún no hay consentimiento.
export const requiereReconsentimiento = ({ fechaNacimiento, consintioTipo, asOf = new Date() } = {}) => {
  if (consintioTipo !== 'tutor') return false
  return isAdult(fechaNacimiento, asOf) === true
}

// Vencido = requiere reconsentimiento y ya pasó el periodo de gracia desde que cumplió 18.
export const reconsentimientoVencido = ({
  fechaNacimiento,
  consintioTipo,
  asOf = new Date(),
  graceDays = GRACIA_RECONSENTIMIENTO_DIAS,
} = {}) => {
  if (!requiereReconsentimiento({ fechaNacimiento, consintioTipo, asOf })) return false
  const cumple18 = fechaCumple18(fechaNacimiento)
  if (!cumple18) return false
  const limite = new Date(cumple18)
  limite.setDate(limite.getDate() + graceDays)
  const ref = parseFecha(asOf) || new Date()
  return ref.getTime() > limite.getTime()
}
